// import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Aboutus from "./Pages/Aboutus";
import Services from "./Pages/Services";
import Contactus from "./Pages/Contactus";
import Portfolio from "./Pages/Portfolio";
function MainRoute() {
  // const userinfo = useSelector((state) => state.auth?.userArray?.user);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/aboutus" element={<Aboutus />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/services" element={<Services/>} />
      <Route path="/contact-us" element={<Contactus/>} />




    </Routes>


  )
}

export default MainRoute
